import {MDCTopAppBar} from '@material/top-app-bar';
import {MDCDrawer} from "@material/drawer";
import {DefaultFocusState, MDCMenu} from '@material/menu';
import lozad from 'lozad';
import axios from 'axios';
import { fromEvent, BehaviorSubject, merge } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

// Lozad.js initialization (for lazy loading)
const observer = lozad();

const topAppBar = MDCTopAppBar.attachTo(document.getElementById('app-bar'));
topAppBar.setScrollTarget(document.getElementById('main-content'));
topAppBar.listen('MDCTopAppBar:nav', () => {
  drawer.open = !drawer.open;
});

const drawer = MDCDrawer.attachTo(document.querySelector('.mdc-drawer'));

document.addEventListener('DOMContentLoaded', function () {
    let lastScrollTop = 0;
    let scrollStatus = true;

    const drawerBackdrop = document.querySelector('.mdc-drawer-backdrop');

    window.addEventListener('scroll', function () {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > lastScrollTop) {
            scrollStatus = false;
        } else {
            scrollStatus = true;
        }
        lastScrollTop = scrollTop;

        // Update the toolbar position based on scrollStatus
        const toolbar = document.getElementById('app-bar');
        if (toolbar) {
            if (scrollStatus) {
                toolbar.style.position = 'fixed';
            } else {
                toolbar.style.position = 'absolute';
            }
        }
    });

    drawerBackdrop?.addEventListener('click', () => {
        drawer.open = false;
    });

    document.body.addEventListener('MDCDrawer:closed', () => {
        drawerBackdrop.classList.remove('mdc-drawer-backdrop-shown');
    });

    document.body.addEventListener('MDCDrawer:opened', function () {
        drawerBackdrop.classList.add('mdc-drawer-backdrop-shown');
    });

    // trigger sublist

    // Select all elements with the 'sublist__provider' class
    const sublistProviders = document.querySelectorAll('.sublist__provider');
        
    // Add click event listener to each sublist provider
    sublistProviders.forEach(element => {
        element.addEventListener('click', function() {
            // Extract the 'data-sublist' attribute value
            const sublistId = element.getAttribute('data-sublist');
            // Toggle the corresponding sublist
            toggleSubList(sublistId);
        });
    });

    function toggleSubList(listId) {
        const subList = document.getElementById(listId);
        subList.style.display = (subList.style.display === 'none') ? 'block' : 'none';
    }

    // search 

    const inputSearchMenu = document.querySelector('input[name="s"]');
    const searchResultsList = document.getElementById('searchResultsList');
    const lessThanThreeLetters = document.getElementById('lessThanThreeLetters');
    const listSearchResults = document.getElementById('listSearchResults');
    const noMoreSearchResults = document.getElementById('noMoreSearchResults');
    const loadingSearchResults = document.getElementById('loadingSearchResults');
    const searchResultItemTemplate = document.getElementById('searchResultItemTemplate');
    const menuSearchResultElement = document.getElementsByClassName('menu-search-results')[0];
    const menuSearchResult = new MDCMenu(menuSearchResultElement);
    menuSearchResult.setDefaultFocusState(DefaultFocusState.NONE);
    let manga_search = [];
    const manga_search_isLoading = new BehaviorSubject(false);
    let search_string = "";

    fromEvent(inputSearchMenu, 'input').pipe(
        debounceTime(1000)
    ).subscribe((event) => {
        search_string = event.target.value;
        if (search_string.trim().length > 2) {
            searchForResults();
        } else {
            manga_search = [];
            updateUI();
        }
    });

    merge(
        fromEvent(inputSearchMenu, 'focus'),
        fromEvent(inputSearchMenu, 'click')
    ).subscribe(() => {
        openMenu();
    });
    
    manga_search_isLoading.subscribe((isLoading) => {
        updateLoadingUI(isLoading);
    });

    function openMenu(){
        menuSearchResult.open = true
    }

    function searchForResults() {
        manga_search_isLoading.next(true);
        axios.get('https://api.abyssreader.com/api/mainMangas/search', {
            params: {
                page: '1',
                size: '3',
                title: search_string
            }
        })
            .then(response => {
                manga_search = response.data.posts;
                manga_search_isLoading.next(false);
                updateUI();
            })
            .catch(error => {
                console.error('Error fetching search results:', error.stack);
                manga_search_isLoading.next(false);
                updateUI();
            });
    }

    function updateLoadingUI(isLoading) {
        if (isLoading) {
            loadingSearchResults.style.display = 'block';
            lessThanThreeLetters.style.display = 'none';
            listSearchResults.style.display = 'none';
            noMoreSearchResults.style.display = 'none';
        } else {
            loadingSearchResults.style.display = 'none';
            updateUI();
        }
    }

    function updateUI() {
        if (search_string.trim().length <= 2) {
            lessThanThreeLetters.style.display = 'block';
            listSearchResults.style.display = 'none';
            noMoreSearchResults.style.display = 'none';
        } else if (manga_search.length > 0) {
            lessThanThreeLetters.style.display = 'none';
            listSearchResults.style.display = 'block';
            noMoreSearchResults.style.display = 'none';
            searchResultsList.style.display = 'block';
            renderSearchResults();
        } else {
            lessThanThreeLetters.style.display = 'none';
            listSearchResults.style.display = 'none';
            noMoreSearchResults.style.display = 'block';
        }
        observer.observe();
    }

    function renderSearchResults() {
        while (listSearchResults.firstChild) {
            listSearchResults.removeChild(listSearchResults.firstChild);
        }
        manga_search.forEach(manga => {
            const newItem = searchResultItemTemplate.cloneNode(true);
            newItem.removeAttribute('id');
            newItem.style.display = 'block';
            newItem.querySelector('.thumbnail').setAttribute("data-background-image", 'https://abyssreader.com/' + manga.thumbnail || '/reousrces/assets/img/placeholder.gif');
            newItem.querySelector('.search-item-title').textContent = manga.title;
            newItem.querySelector('.rating-value').textContent = manga.averageRating.toFixed(2);
            newItem.querySelector('.chapters-count').textContent = manga.maxChaptersCount;
            const link = newItem.querySelector('.search-item-link');
            link.href = `/manga/${manga.slug}`;
            link.title = manga.title;
            listSearchResults.appendChild(newItem);
        });
    }
});
